import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatSnackBar } from '@angular/material';
import { MaterialService } from "../../services/material.service";
import { LearnerService } from "../../services/learner.service";
import { JobService } from "../../services/jobs/job.service";
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { Select2OptionData } from 'ng2-select2';
import { Observable } from 'rxjs';
import { AllotmentConfirmationComponent } from './allotment-confirmation/allotment-confirmation.component';
import { DocumentsComponent } from '../../documents/documents.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { saveAs } from "file-saver";
import * as moment from 'moment';
import { assignmentTypes, notQuizAssignmentTypes, quizAssignmentTypes } from '../../_models/staticArray'
import { DownloadService } from '../../services/download.service'
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'app-assignment-status',
  templateUrl: './assignment-status.component.html',
  styleUrls: ['./assignment-status.component.scss']
})

export class AssignmentStatusComponent implements OnInit, OnChanges {


  public learnerToDisplay: Array<Select2OptionData> = [];
  public optionsForlearners: Select2Options;
  public currentLearner: string;
  public unitsToDisplay: Array<Select2OptionData> = [];
  public optionsForUnits: Select2Options;
  public currentUnit: string;
  resetSelectedId: boolean
  unitArrayCopy: any;
  selectedLearnerArray: any[];
  selectedUnitsArray: any[];
  allotmentArray = [];
  allLearners: any;
  showAllocate: boolean;
  assignment;
  learnerList = []
  // displayedColumns: string[];
  learners: [];

  displayedColumns: string[] = ['name', 'email', 'actions'];
  dataSource: MatTableDataSource<any>;

  learner = [];
  job;
  jobId;
  unit;
  unitArray;
  assignmentLength;
  learnerLength;
  loading: Boolean = false;
  selectedLearners;
  selectedUnits;
  singleJobDetails
  @Input('jobId') jobIdFromClient;
  @Input('learnersFromJob') learnersFromJob;
  @Input('singleJob') jobDetails
  @Output() allocatedFromStatus: EventEmitter<any> = new EventEmitter<any>();
  @Output() assignmentList: EventEmitter<any> = new EventEmitter<any>();
  selectedElementId: any = [];
  currentUser: any;
  types = assignmentTypes
  // [
  //   {
  //     id: 1,
  //     text: 'File'
  //   },
  //   {

  //     id: 2,
  //     text: 'Knowledge Assessment'
  //     // }
  //   }
  // ]
  selectedType: any
  displayType: any
  user;
  isClient: boolean;
  noDataMsg = {
    title: "No Learners!",
    data: "You have not yet assigned any learners"
  }
  hoverIndex: any;
  assignmentsForPdf = [];
  alreadySelected = []
  removeElement = []
  private learnerRemove: Subject<any> = new Subject<any>();
  private addLearnerSubscription: Subject<any> = new Subject<any>();

  constructor(private datePipe: DatePipe, private activatedRoute: ActivatedRoute,
    private _materialService: MaterialService, private _learnerService: LearnerService, private _jobService: JobService,
    public dialog: MatDialog, public _snackBar: MatSnackBar,
    public _change: ChangeDetectorRef, public _downloadService: DownloadService, public _utilityServices: UtilityService,
  ) {
    this.learners = [];
    this.dataSource = new MatTableDataSource(this.learners);
    this._learnerService.newLearnerObservable()
      .pipe(
        takeUntil(this.addLearnerSubscription)
      )
      .subscribe((newLearner) => {
        console.log("who is new learner", newLearner);

        let learnerArray = this.allLearners;
        newLearner.learner['checked'] = false
        learnerArray.push(newLearner.learner)
        this.allLearners = [];
        this.allLearners = [...learnerArray]
        console.log("new learner added ", this.allLearners);
        // this.learner.push(newLearner.learner)
        if (this.singleJobDetails.course.courseMetaId.trackerType.includes('quiz')) this.quizStatusWithLearner()
        else this.assignmentListForChild()
        // this.learnerList.push(newLearner.learner)
        // this._change.detectChanges();
      });

    this._learnerService.removeLearnerObservable()
      .pipe(
        takeUntil(this.learnerRemove)
      )
      .subscribe((learner) => {
        console.log("when learner remove from job", learner);
        console.log("isLearnerRemove subscribe==>", (!this.learnerRemove.closed))
        let index = this.learner.findIndex(x => x._id === learner._id);
        if (index > -1) {
          this.learner.splice(index, 1)
          // this.learnerList.splice(index,1)
          console.log("after learner remove in assignment page", this.learner);

          // this.updateData(this.learners)
        }
      })

  }


  @ViewChild(DocumentsComponent, { static: false }) documentComp: DocumentsComponent;

  // public test() {
  //   console.log("CALLED FROM MATERIALS");
  // }

  ngOnDestroy() {
    this.learnerRemove.next();
    this.learnerRemove.complete();
    this.addLearnerSubscription.next();
    this.addLearnerSubscription.complete();

    console.log("this.learnerRemove!!!", (!this.learnerRemove.closed))
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log("IN ON CHANGES When Page is load", changes);
    if (changes.learnersFromJob && changes.learnersFromJob.currentValue) {
      this.allLearners = changes.learnersFromJob.currentValue
    }
    console.log("all learners list", this.allLearners);

    if (changes.jobIdFromClient && changes.jobIdFromClient.currentValue) {
      console.log("in assignmentStatus", changes.jobIdFromClient.currentValue);
      this.jobIdFromClient = changes.jobIdFromClient.currentValue
      this.jobId = changes.jobIdFromClient.currentValue
      // this.getAssignmentList(this.jobIdFromClient)
      // this.assignmentStatusWithLearner()
    }
    if (changes.jobDetails && changes.jobDetails.currentValue) {
      console.log("what is the current job detaalis", changes.jobDetails.currentValue);
      this.singleJobDetails = changes.jobDetails.currentValue
      let objLength = Object.keys(this.singleJobDetails)
      if (objLength && objLength.length) {
        if (this.singleJobDetails.course.courseMetaId.trackerType.includes('quiz') && this.singleJobDetails.course.courseMetaId.trackerType.includes('file')) {
          this.types = assignmentTypes
          this.selectedType = 'File'
          this.getAssignmentList(this.jobIdFromClient)
          this.assignmentListForChild()
        }

        else if (this.singleJobDetails.course.courseMetaId.trackerType.includes('quiz')) {
          this.selectedType = 'Knowledge Assessment'
          this.types = quizAssignmentTypes
          this.getQuizOfMaterial()
          this.quizStatusWithLearner()
        } else {
          console.log("what is the selected file type", this.selectedType);
          this.types = notQuizAssignmentTypes
          this.selectedType = 'File'
          this.getAssignmentList(this.jobIdFromClient)
          this.assignmentListForChild()
        }
      }
    }
  }

  ngOnInit() {
    console.log("ng on init call is important", ' ');

    // this.loading = true
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.isClient = this.user.isClient ? true : false
    if (this.jobIdFromClient != undefined) {
      this.jobId = this.jobIdFromClient
    }
    else {
      console.log("call this else part ot not", ' ');

      this.activatedRoute.params.subscribe(params => {
        this.jobId = params['jobid'];
        // console.log("Calling getLearners with jobid = ", this.jobId);
      });
    }
    // if (this.learnersFromJob) {
    //   console.log("*****this.learnersFromJob", this.learnersFromJob);
    //   this.allLearners = this.learnersFromJob
    // }

    // this.getAssignmentList(this.jobId);
    // this.assignmentListForChild()
    // this.assignmentStatusWithLearner();
    // this.getLearnerList()
  }


  learnersSelected() {
    console.log("***seleted Learners are", this.selectedLearners);
  }

  changedUnit(data: { value: string[] }) {
    console.log("change", data);
    this.currentUnit = data.value.join(',');
    // this.queryParamsObj['instructorId'] = this.current;
    console.log("this.current", this.currentUnit);
  }

  getFilteredData() {
    this.selectedLearnerArray = []
    if (this.selectedLearners) {
      this.selectedLearners.forEach(learner => {
        console.log("in for each learner is", learner);
        this.selectedLearnerArray.push(learner._id)
      })
    }




    console.log("selected learners value", this.selectedLearnerArray);


    this.selectedUnitsArray = []
    if (this.selectedUnits) {
      this.selectedUnits.forEach(unit => {
        console.log("in for each unit is", unit);
        this.selectedUnitsArray.push(unit.unitId)
      })
    }

    // this.loading = true;
    console.log("**this.selectedLearners", this.selectedLearners, "selectedLearnersArray", this.selectedLearnerArray);
    console.log("**this.selectedUnits", this.selectedUnits, "selectedUnitsArray", this.selectedUnitsArray);
    if (this.selectedUnitsArray && this.selectedUnitsArray.length > 0) {
      this.unitArray = []
      this.selectedUnitsArray.forEach(unit => {
        let index = _.findIndex(this.unitArrayCopy, function (o) { return o.unitId == unit })
        if (index > -1) this.unitArray.push(this.unitArrayCopy[index])
      })
    }
    else this.unitArray = this.unitArrayCopy

    // this.assignmentStatusWithLearner()



    console.log("selcted type", this.selectedType);
    console.log("what is display type", this.displayType);


    if (this.selectedType.text == 'Knowledge Assessment' || this.selectedType == 'Knowledge Assessment') {
      console.log("what is unit array ", this.unitArray);

      if (this.displayType == 'File') {
        this.unitArray = []
        this.getQuizOfMaterial()
      }
      this.quizStatusWithLearner()
    }
    if (this.selectedType.text == 'File' || this.selectedType == 'File') {
      console.log("call this or not", this.selectedType, this.displayType);

      if (this.displayType == 'Quiz' || this.displayType == 'Quiz') {
        this.unitArray = []
        this.getAssignmentList(this.jobId)
      }
      this.assignmentListForChild()
    }

  }


  quizColspan(unit) {
    let count = 0

    if (unit && unit.quiz && unit.quiz.length) return unit.quiz.length
    else return 0


    // for (let i = 0; i < unit.assignment.length; i++) {

    //   if (unit.assignment[i].quiz && unit.assignment[i].quiz.length) {
    //     count = count + unit.assignment[i].quiz.length
    //   }
    // }

    // if (count >= 1) {
    //   // console.log("total colspan data", count);

    //   return count
    // } else {
    //   return 0
    // }
  }
  assignmentColspan(unit) {
    console.log("single unit for assignment", unit);

    return unit.quiz.length
  }


  getAssignmentList(jobId) {
    // this.loading = true
    console.log("call this for job id", jobId);
    this.unitArray = []

    this._materialService.getMaterialUsingJobId(jobId).subscribe((data) => {
      console.log("details of unit array", data);
      if (data && data.length) {

        this.unitsToDisplay = []
        this.unit = data[0];
        console.log("unit data", this.unit)
        this.unitArray = data;
        console.log("%c**this.unitArray ", "color:red", this.unitArray);
        this.unitArrayCopy = data
        // if (this.documentComp) {
        console.log("call this or not for units", this.unitArray);
        // if (data && data.length) {
        //   this.documentComp.getAssignment(JSON.stringify(this.unitArray))
        // }
        this.displayType = 'File'
        this.assignmentList.emit(data)
        data.forEach(value => {
          console.log("what is value", value);

          if (value._id != null) {
            let temp = {
              id: value._id,
              text: "Unit - " + value._id + '  ' + value.title,
              unitId: value.unitId
            }
            this.unitsToDisplay.push(temp)
          }

        })
        console.log("**unit data is ", this.unitsToDisplay);
        this.assignment = data.assignment;
        this.assignmentLength = this.unit.assignment.length;
        console.log("*****assignmentLength", this.assignmentLength);
      } else {
        this.unitArray = []
        this.displayType = 'File'
        this.noDataMsg = {
          title: "No Files!",
          data: "You have not yet any files"
        }
      }
      // this.loading = false
    });
  }





  getQuizOfMaterial() {
    this.unitArray = []
    // this.loading = true
    this._materialService.getQuziOfMaterial(this.jobId).subscribe((data: any) => {
      console.log("data of all quiz ", data);
      if (data && data != undefined) {

        this.unitsToDisplay = []
        this.unit = data[0];
        this.unitArray = data;
        console.log("%c**this.unitArray ", "color:red", this.unitArray);
        this.unitArrayCopy = data
        this.displayType = 'Quiz'
        // if (this.documentComp) {
        console.log("call this or not for units", this.unitArray);
        // if (data && data.length) {
        //   this.documentComp.getAssignment(JSON.stringify(this.unitArray))
        // }

        this.assignmentList.emit(data)
        data.forEach(value => {
          if (value._id != null) {
            let temp = {
              id: value._id,
              unitId: value.unitId,
              text: "Unit - " + value._id + '  ' + value.title
            }
            this.unitsToDisplay.push(temp)
          }

        })
        console.log("**unit data is ", this.unitsToDisplay);
        this.assignment = data.assignment;
        this.assignmentLength = this.unit.assignment.length;
        console.log("*****assignmentLength", this.assignmentLength);
      } else {
        this.noDataMsg = {
          title: "No Quiz!",
          data: "You have not yet any Quiz"
        }
        this.displayType = 'Quiz'
      }

      // });
    }, error => {
      console.log("error while gte ", error);
      // this.loading = false
    })
  }

  loadLearners(object) {
    // console.log("OBJECT", object);
    this.learners = object.learners;
    // console.log("Learners loaded by event = ", object.learners);
  }

  checkArray(assignmentArray, assignment) {
    if (assignmentArray && assignmentArray.length != 0) {
      let index = _.findIndex(assignmentArray, function (o) { return o.assignmentId == assignment; });
      if (index >= 0) {
        return assignmentArray[index].assignmentStatus;
      } else {
        return 'Unassigned';
      }
    } else {
      return 'Unassigned';
    }
  }



  checkQuizArray(assignmentArray, assignment) {
    // console.log("what is the assignment array", assignmentArray);
    // console.log("check this for final array", assignment);

    if (assignmentArray && assignmentArray.length != 0) {
      let index = _.findIndex(assignmentArray, function (o) { return o.quizId == assignment; });
      // console.log("index", index);

      if (index > -1) {
        return assignmentArray[index].status;
      } else {
        return 'Pending';
      }
    } else {
      return 'Pending';
    }
  }

  checkArrayWithDate(assignmentArray, assignment) {
    let index = _.findIndex(assignmentArray, function (o) { return o.assignmentId == assignment; });
    if (index >= 0) {
      const statusAndDate = assignmentArray[index].assignmentStatus + ' on ' + this.datePipe.transform(assignmentArray[index].updatedAt, 'MMMM d, y');
      return statusAndDate;
    } else {
      return this.isClient ? 'Unassigned' : 'Click to Allocate';
    }
  }


  allotmentArrayList(event) {
    if (event && event.length) {
      this.allotmentArray = event
      this.showAllocate = true
    } else {
      this.showAllocate = false
    }
  }

  checkQuizArrayWithDate(assignmentArray, assignment) {
    let index = _.findIndex(assignmentArray, function (o) { return o.quizId == assignment; });

    if (index >= 0) return assignmentArray[index].status + ' on ' + this.datePipe.transform(assignmentArray[index].created, 'MMMM d, y');
    else return this.isClient ? 'Unassigned' : 'Click to Allocate';
  }

  checkArrayForRouting(assignmentArray, assignment) {
    let index = _.findIndex(assignmentArray, function (o) { return o.assignmentId == assignment; });
    if (index >= 0) return assignmentArray[index].allotmentId;
    else return 'Unassigned';
  }

  assignmentSelection(event) {
    if (event && event.length && event.duedate != null) {
      console.log("event check here ==>", event)
      this.alreadySelected = event
    } else {
      this.alreadySelected = []
    }
  }

  unitColspan(unit) {
    // console.log("what is the unit of colspan", unit);
    let count = 0

    for (let i = 0; i < unit.assignment.length; i++) {

      if (unit.assignment[i].quiz && unit.assignment[i].quiz.length) {
        count = count + unit.assignment[i].quiz.length
      }
    }

    if (count >= 1) {
      // console.log("total colspan data", count);

      return count
    } else {
      return unit.assignment.length
    }


  }



  unassignedClicked(learn, assignment, learnIndex, assignIndex, event) {
    this.selectedElementId.push(assignment.assignmentId + learn._id)
    let newData = {
      learner: learn,
      assignment: assignment,
      duedate: null
    }
    if (event.target.classList.value == 'Unassigned') {
      $("#Unassigned" + assignment.assignmentId + learn._id).removeClass('Unassigned');
      $("#Unassigned" + assignment.assignmentId + learn._id).addClass('selected');
    }
    else if (event.target.classList.value == 'selected') {
      $("#Unassigned" + assignment.assignmentId + learn._id).removeClass('selected');
      $("#Unassigned" + assignment.assignmentId + learn._id).addClass('Unassigned');
    }

    if (this.allotmentArray) {
      let index = _.findIndex(this.allotmentArray, function (o) { return (o.learner.learnerId == newData.learner.learnerId && o.assignment.assignmentId == newData.assignment.assignmentId) })
      if (index > -1) this.allotmentArray.splice(index, 1)
      else this.allotmentArray.push(newData)
    }
    if (this.allotmentArray.length > 0) {
      this.showAllocate = true
    }
    else this.showAllocate = false
    console.log("this.allotmentArray", this.allotmentArray);
  }
  allocate() {

    this.openDialog(AllotmentConfirmationComponent)
      .subscribe((allot) => {

        if (allot == undefined) {
          console.log("what is the allotmnet", allot, this.alreadySelected);

          // if (this.selectedElementId.length > 0) {
          //   this.selectedElementId.forEach(id => {
          //     $("#Unassigned" + id).removeClass('selected');
          //     $("#Unassigned" + id).addClass('Unassigned');
          //   })
          // }
          this.removeElement = this.alreadySelected
          // this.selectedElementId = this.alreadySelected
          console.log("selected ==>", this.selectedElementId)
          if (this.selectedElementId && this.selectedElementId.length)
            this.showAllocate = true;
          else this.showAllocate = false;
          return
        }
        else {
          let allotArray = [];
          this.allotmentArray.forEach(obj => {
            console.log("what is single unit data", obj);

            // obj.assignment['assignmentUnit'] = obj.assignment.assignmentUnit.unitNo

            let allotObj = {
              learner: {
                _id: obj.learner.learnerId,
                learnerId: obj.learner.learnerId,
                learnerName: obj.learner.learnerName
              },
              assignment: {
                assignmentId: obj.assignment.assignmentId,
                assignmentNo: obj.assignment.assignmentNo,
                assignmentTitle: obj.assignment.assignmentTitle,
                assignmentType: obj.assignment.assignmentType,
                assignmentUnit: obj.assignment.assignmentUnit
              },
              duedate: allot
            }
            allotArray.push(allotObj)
          })
          console.log("this.allotmentArray", allotArray);
          this._learnerService
            .allocateLearnerFromStatus({ allotArray, jobId: this.jobId })
            .subscribe(res => {
              this.loading = true
              console.log("**Response", res);
              this.allotmentArray = [];
              this.selectedElementId = []
              // this.resetSelectedId = true 
              console.log("here is the assigntstatus  ===>", this.alreadySelected)
              this.showAllocate = false
              this.loading = false
              // this.assignmentStatusWithLearner()
              this.assignmentListForChild()
            }, err => {
              console.log('Error here==>', err);
              this.loading = false;
            })
        }
        this.allocatedFromStatus.emit({ text: 'allocated' })
      })
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  assignmentStatusWithLearner() {
    let learner, unitNo
    // learner = this.selectedLearnerArray ? this.currentLearner.split(',') : undefined
    // unitNo = this.currentUnit ? this.currentUnit.split(',') : undefined
    let data = {
      _id: this.jobId,
      learner: this.selectedLearnerArray,
      unitNo: this.selectedUnitsArray
    }

    console.log('data============================>>>>>>>>>>>>', data);

    this._materialService.assignmentStatusWithLearner(data).subscribe((data) => {
      if (data.length == 0) {
        return;
      } else {
        this.learnerList = data;
        console.log('this.learner======~~~~~', this.learner);
        data.forEach(value => {
          let temp = {
            id: value._id,
            text: value.learnerName
          }
          this.learnerToDisplay.push(temp)
        })
        console.log("**learnerToDisplay", this.learnerToDisplay);
        this.learnerLength = this.learner.length;
        this.loading = false
        // this.getLearnerList()
      }
    });
  }



  assignmentListForChild() {
    this.loading = true
    this.learnerList = []
    let data = {
      _id: this.jobId,
      learner: this.selectedLearnerArray,
      unitNo: this.selectedUnitsArray,
      courseId: this.singleJobDetails.course._id
    }
    this._materialService.getAssignmentListForChild(data).subscribe((response) => {
      console.log("response of all materials", response);
      if (response && response != undefined) {

        this.learnerList = response
        response.forEach(value => {
          let temp = {
            id: value._id,
            text: value.learnerName
          }
          this.learnerToDisplay.push(temp)
        })
        console.log("**learnerToDisplay", this.learnerToDisplay);
        this.learnerLength = this.learner.length;
      }
      setTimeout(() => {

        this.loading = false
      }, 2000)
    })

  }


  quizStatusWithLearner() {
    this.loading = true
    let data = {
      _id: this.jobId,
      learner: this.selectedLearnerArray,
      unitNo: this.selectedUnitsArray
    }

    console.log('data============================>>>>>>>>>>>>', data);
    this.selectedType = 'Knowledge Assessment'
    this._materialService.quizStatusWithLearner(data).subscribe((data) => {
      console.log("what is the data", data);

      if (data && data.length == 0) {
        return;
      } else {
        this.learnerList = data;
        console.log('this.learner======~~~~~', this.learner);
        data.forEach(value => {
          let temp = {
            id: value._id,
            text: value.learnerName
          }
          this.learnerToDisplay.push(temp)
        })
        console.log("**learnerToDisplay", this.learnerToDisplay);
        this.learnerLength = this.learner.length;
        // this.getLearnerList()
      }
      // this.loading = false
      setTimeout(() => {

        this.loading = false
      }, 2000)
    });
  }


  getLearnerList() {
    console.log("**getLearnerList called");
    this._learnerService.getLearnersByJobId(this.jobId).subscribe(learners => {
      this.allLearners = learners
      console.log("**this.allLearners", this.allLearners);

    })
  }
  learnerIndex(i) {
    this.hoverIndex = i
    console.log("ijdfdo", i);
  }
  learnerIndexChanged(i) {
    // this.hoverIndex = -1
  }

  download() {
    this.loading = true
    let obj = {
      singleJobDetails: this.singleJobDetails,
      learnerList: this.learnerList,
      unitArrayCopy: this.unitArrayCopy,
      csvType: 'assignmentTracker'
    }

    this._downloadService.downloadCSV(obj).subscribe((csvResponse) => {
      console.log("hello here is the reponse of csvResponse .....", csvResponse)
      this.loading = false
      const downloadLink = document.createElement("a");
      if (csvResponse && csvResponse.data) {
        this._utilityServices.handleSnackBar({ msg: "CSV download Successfully!", button: "Ok" })
        downloadLink.href = csvResponse.data;
        downloadLink.click();
      }
    }, (error) => {
      this.loading = false
      this._utilityServices.handleSnackBar({ msg: "CSV download Fail!", button: "Ok" })
      console.log("SOME error occure ===>", error)
    })


  }

  getAssignmentListForPdf() {
    return new Promise((resolve, reject) => {
      this.assignmentsForPdf = []
      const length = this.unitArrayCopy.length
      this.unitArrayCopy.forEach((obj, index) => {
        this.assignmentsForPdf = this.assignmentsForPdf.concat(obj.assignment)
        if (index == length - 1) {
          resolve(this.assignmentsForPdf)
          console.log("this.assignmentsForPdf", this.assignmentsForPdf)
        }
      })
    })
  }
}